var _excluded = ["codes", "onRemoveCode"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Box } from '@chakra-ui/react';
import { A, Span } from "../../../../common/components/text";
import { useTranslate } from "../../../../common/context/Translate";
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 *
 * AppliedPromoCodesList Component to render applied promos and initiate removal of promos from order.
 */
export var AppliedPromoCodesList = _ref => {
  var {
      codes = [],
      onRemoveCode
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var showList = codes.length > 0;
  var t = useTranslate();
  if (!showList) {
    return null;
  }
  return ___EmotionJSX(Box, _extends({
    "data-testid": "checkoutAppliedPromoCodeList",
    marginBottom: "10px"
  }, props), codes.map(code => ___EmotionJSX(Box, {
    "data-testid": "checkoutPromoCodesApplied",
    key: code
  }, ___EmotionJSX(Span, null, code, " ", t('Applied')), ___EmotionJSX(A, {
    "data-testid": "checkoutRemoveAppliedPromoCode",
    onClick: () => onRemoveCode(code),
    marginLeft: "10px"
  }, t('Remove')))));
};